<template>
  <v-container fluid>
    <v-layout >
      <v-flex xs12>
        <v-card>
          <v-container fluid grid-list-md>
            <v-row>
                <!-- User List -->

                <v-col cols="12" md="3">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-text-field
                        hide-details
                        append-icon="search"
                        v-model="filter"

                        label="Alt kullanıcılarda arama yap">
                      </v-text-field>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-list shaped flat max-height="540" class="overflow-y-auto">
                      <v-list-item-group>
                        <v-subheader>Ana Kullanıcı</v-subheader>
                        <v-list-item @click="onUser = 'Ana Kullanıcı'">
                          <v-list-item-avatar>
                            <v-icon>person</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>{{ user.name }}</v-list-item-title>
                            <v-list-item-subtitle>0{{ user.phone }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-subheader>Alt Kullanıcılar</v-subheader>
                        <v-list-item
                          v-for="(user, i) in filteredSubUsers" :key="i"
                          @click="prepareUser(user)">
                          <v-list-item-avatar>
                            <v-icon>people_alt</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="user.name"></v-list-item-title>
                            <v-list-item-subtitle v-text="0 + user.phone"></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                      <v-card-title v-if="filteredSubUsers.length === 0">
                        Aradağınız Kelimeye Uygun Sonuç Bulunamadı!
                      </v-card-title>
                    </v-list>
                  </v-card>
                </v-col>

                <!-- User Notifications List  -->
                <v-scroll-y-transition>
                  <v-col cols="12" md="9">
                    <v-card elevation="0">
                      <v-toolbar flat>
                        <v-toolbar-title>Tüm Bildirimler - <b>{{ onUser }}</b></v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-list rounded v-if="usersNotifications.length" max-height="540" class="overflow-y-auto">
                          <v-list-item-group multiple v-model="usersReadNotifications">
                            <v-list-item
                              v-for="(notification, i) in usersNotifications"
                              :key="i">
                              <v-list-item-title>{{ notification.message }}</v-list-item-title>
                              <v-list-item-subtitle>
                                {{ notification.created_at }}
                              </v-list-item-subtitle>
                              <v-divider></v-divider>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                        <v-card-title v-else >
                          Kullanıcıya Ait Gösterilecek Bildirim Bulunmamakta!
                        </v-card-title>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-scroll-y-transition>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Notifications',
  data: () => ({
    filter: '',
    onUser: 'Ana Kullanıcı',
    subUsers: [],
    userNotifications: [],
    usersNotifications: [],
    usersReadNotifications: [],
    pagination: {
      current: '',
      total: '',
    },
  }),
  async created() {
    const route = 'notifications/with/subusers';

    await this.send({ route })
      .then(async (res) => {
        this.subUsers = res.data.data.subUsersNotifications;
        this.userNotifications = await res.data.data.notifications.data;
        this.pagination.total = res.data.data.notifications.last_page;
        this.pagination.current = res.data.data.notifications.current_page;
        this.sanitizeNotificationState(this.userNotifications);
      });
  },
  methods: {
    ...mapActions({ send: 'asyncSender' }),
    prepareUser(user) {
      this.sanitizeNotificationState(user.notifications);
      this.onUser = user.name;
    },
    async sanitizeNotificationState(notifications) {
      await notifications.forEach((el, i) => el.read !== '1' || this.usersReadNotifications.push(i));
      this.usersNotifications = notifications;
    },
  },
  computed: {
    ...mapState(['user']),
    filteredSubUsers() {
      return this.subUsers.filter(
        user => user.name.toLowerCase().includes(this.filter.toLowerCase()),
      );
    },
  },
};
</script>
